// Add your custom JS here.

// home page scroll magic fade in objects. 


(function($) {


    

    $(document).ready(function(){

        gsap.registerPlugin(ScrollTrigger);


        // ---- ES mini page ----

        // All product text in loop

          const esMiniTextProducts = gsap.utils.toArray('.es-mini-text-product');
            esMiniTextProducts.forEach(productTextMini => {
            gsap.from(productTextMini, { 
                opacity: 0.3,
                duration: 1.2,
                ease: "power1.in",
                translateY: 40,
                scrollTrigger: {
                    trigger: productTextMini,
                    opacity: 1, 
                
                }
            })
            });


            // All images in loop 

            const esMiniImages = gsap.utils.toArray('.es-mini-image-product');
            esMiniImages.forEach(productImageMini => {
            gsap.from(productImageMini, { 
                opacity: 0.2,
                duration: 2,
                scrollTrigger: {
                    trigger: productImageMini,
                    start: "top 80%",
                    opacity: 1, 
                
                }
            })
            });

            const esMiniVideos = gsap.utils.toArray('.es-mini-video-product');
            esMiniVideos.forEach(productVideoMini => {
            gsap.from(productVideoMini, { 
                opacity: 0.2,
                duration: 2.5,
                scrollTrigger: {
                    trigger: productVideoMini,
                    start: "top 80%",
                    opacity: 1, 
                }
            })
            });



        // ----- Home page images -----

            gsap.from(".home-image-1", {
                opacity: 0, 
                duration: 2,
                ease: "power1.in",
                translateY: 40,
                //scrub: true,
                scrollTrigger: {
                    trigger: ".home-image-1",
                    toggleActions: "restart none none none",
                    //onEnter onLeave onEnterBack onLeaveBack
                    //play pause resume reverse restart reset complete none
                }
                
            })


            gsap.from(".home-image-2", {
                opacity: 0, 
                duration: 3,
                ease: "power2.in",
                translateX: 40,
                //scrub: true,
                scrollTrigger: {
                    trigger: ".home-image-2",
                    toggleActions: "restart none none none",
                }
                    
                
            })

            
            // -----  Article and team cards -----
         
            gsap.set(".card", {
                opacity: 0,
                y: 50,
                scale: 0.7,
            
            })
           
        


            ScrollTrigger.batch(".card", {
                onEnter: elements => {
                    gsap.to(elements, {
                    opacity: 1,
                    duration: .5,
                    scale: 1,
                    x: 0,
                    y: 0,
                    stagger: 0.3,
                    ease: "expo.out",
                    
                    })
                }
            });


           


                
       

     });


    

}) ( jQuery );